import { MenuItem } from '@material-ui/core';
export const getErrorProps = (formik, name) => {
    return {
        error: (name in formik.errors),
        helperText: formik.errors[name]
    }
}

let id = 0
export const newid = () => {
    return --id
}

export const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export const getOptions = (list) => {
    return list.filter(item => !item.hide).map(item => {
        return (
            <MenuItem key={item.id} value={item.value}>
                {item.name}
            </MenuItem>
        )
    })
}

export const plotItems = (plots) => {
    return plots.map(item => {
        return (
            <MenuItem key={item.id} value={item.id}>
                {item.description}
            </MenuItem>
        )
    })

}

export const excrementScales = () => {
    return [
        { code: 'I', description: 'geen mest gevonden' },
        { code: 'A', description: 'vers: enkele keutels' },
        { code: 'C', description: 'vers: grotere hoeveelheid keutels' },
        { code: 'E', description: 'vers: duidelijke mesthoop' },
        { code: 'G', description: 'vers: grote mesthoop' },
        { code: 'B', description: 'oud: enkele keutels' },
        { code: 'D', description: 'oud: grotere hoeveelheid keutels' },
        { code: 'F', description: 'oud: duidelijke mesthoop' },
        { code: 'H', description: 'oud: grote mesthoop' },
        { code: '+', description: 'mest algemeen' },
        { code: 'vers', description: 'mest algemeen (vers)' },
        { code: 'oud', description: 'mest algemeen (oud)' }
    ]

}

export const findPlot = (plots, plot) => {
    var found = null;
    for (const p1 of plots) {
        if (p1.id === plot) {
            found = p1
            break
        }
        found = p1.children.find(p2 => p2.id === plot)
        if (found) break
    }
    return found
}

export const observers = (plot, roles) => {
    if (!plot) return []
    const persons = plot.roles.filter(role => role.statusId === 1).map((role) => role.person)
    const extra = roles.filter(role => role.statusId === 1 && !persons.some((person) => person.id === role.person.id)).map((role => role.person))
    return ([...persons, ...extra])
}